<template>
  <!-- 对话框 -->
  <el-dialog :visible.sync="show" width="800px" :before-close="closeDialog" center :show-close="false">

    <div style="max-height: 50vh ;overflow-y: auto;" class="box">
      <el-form label-width="80px">

        <el-form-item label="以往选择标签:" label-width='100px' v-if="pastLabelCheckboxGroup.length!=0">


          <el-tag v-for="(item, index) in pastLabelCheckboxGroup" style="margin-right: 10px;">{{ item }}</el-tag>



        </el-form-item>


        <el-form-item label="回访标签:" label-width='100px'>


          <el-checkbox-group v-model="labelCheckboxGroup" size="medium">

            <el-checkbox border v-for="(tag,index) in dynamicTags" :label="tag.label_code">{{ tag.label }}</el-checkbox>

          </el-checkbox-group>


        </el-form-item>






        <el-form-item label="是否添加微信:" label-width='100px'>


          <el-radio-group v-model="submit_data.is_add_wx" size="medium">
            <el-radio-button label="1">已添加</el-radio-button>
            <el-radio-button label="0">未添加</el-radio-button>
          </el-radio-group>


        </el-form-item>


        <el-form-item label="是否检车:" label-width='100px'>


          <el-radio-group v-model="submit_data.is_inspection" size="medium">
            <el-radio-button label="1">是</el-radio-button>
            <el-radio-button label="0">否</el-radio-button>
          </el-radio-group>


        </el-form-item>


        <el-form-item label="是否充值:" label-width='100px'>


          <el-radio-group v-model="submit_data.is_recharge" size="medium">
            <el-radio-button label="1">是</el-radio-button>
            <el-radio-button label="0">否</el-radio-button>
          </el-radio-group>


        </el-form-item>




        <el-form-item label="备注:" label-width='100px'>


         <el-input v-model="submit_data.remarks" type="textarea"></el-input>


        </el-form-item>


        <el-form-item label="回访客服:" label-width='100px' v-if="admin_name!=''">


          <span>{{ admin_name }}</span>


          </el-form-item>



        <el-form-item label="回访时间:" label-width='100px' v-if="time!=''">


         <span>{{ time }}</span>


         </el-form-item>



      </el-form>



    </div>

    <!-- 对话框底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="onSubmit" type="primary">确认</el-button>
      <el-button @click="closeDialog">返回</el-button>
    </span>

  </el-dialog>
</template>

<script>
  var _this;
  export default {

    props: {
      'isShow': Boolean,
      'data': '',
      'status': '',
      'phone':''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.submit_data.order_code = _this.data;

        _this.$post(
            "/label/labelLists", {
              status: '1'
            }
          )
          .then(res => {

            _this.dynamicTags = res.data.admin.visit.label
            for (let index = 0; index < res.data.admin.visit.label.length; index++) {

              _this.type_arr.push('2');

            }

          }).catch(res => {

          })


        if (_this.status == '1') {

          _this.$post(
              "/order/getVisitOrderDetails", {
                order_code: _this.data
              }
            )
            .then(res => {

              _this.pastLabelCheckboxGroup = res.data.synchronization;

              _this.submit_data.is_add_wx = res.data.is_add_wx.val;

              _this.submit_data.is_inspection = res.data.is_inspection.val;

              _this.submit_data.is_recharge = res.data.is_recharge.val;

              _this.submit_data.remarks = res.data.remarks;

              _this.time = res.data.time.YmdHis;

              _this.admin_name = res.data.admin_name;


              console.log(_this.submit_data.is_add_wx);


            }).catch(res => {

            })

        }






      },
    },
    data() {
      return {


        show: false,

        labelCheckboxGroup: [],

        satisfiedCheckboxGroup: [],

        wxCheckboxGroup: '',

        pastLabelCheckboxGroup:[],

        processingCheckboxGroup:'',

        time:'',

        admin_name:'',

        // 标签
        dynamicTags: [],
        inputVisible: false,
        inputValue: '',


        // 表单数据
        submit_data: {
          order_code: '',
          visit_code_array: '',
          remarks: '',
          is_add_wx:'',
          is_inspection:'',
          is_recharge:''
        },
        submit_rules: {
          visit_code_array: {
            placeholder: '回访标签',
            rules: {
              required: true,
              message: '回访标签不能为空',
              regulation: 'egt_str',
              rulesData: 0
            }
          },
          remarks: {
            placeholder: '备注',
            rules: {
              required: false,
              message: '未填写支付金额',
              regulation: 'elt_str',
              rulesData: 200
            }
          },
        }

      };
    },
    created() {

      _this = this;

    },
    methods: {


      onSubmit() {

        _this.submit_data.visit_code_array = JSON.stringify(_this.labelCheckboxGroup);

        if(_this.status == '1'){

          _this.$post(
              "/order/editVisitOrderSubmit",
              _this.submit_data,
              _this.submit_rules
            )
            .then(res => {

              _this.$message.success(res.msg);

              _this.closeDialog();

              _this.$emit('onSubmit');

            }).catch(res => {

            })

        }else{

          _this.$post(
              "/order/visitOrderSubmit",
              _this.submit_data,
              _this.submit_rules
            )
            .then(res => {

              _this.$message.success(res.msg);

              _this.closeDialog();

              _this.$emit('onSubmit');

            }).catch(res => {

            })


        }


      },



      closeDialog() {


        _this.show = false;

        _this.dynamicTags = [];

        _this.labelCheckboxGroup = [];

        _this.pastLabelCheckboxGroup = [];

        _this.time = '';

        _this.admin_name = '';

        _this.submit_data = {
          order_code: '',
          visit_code_array: '',
          remarks: '',
          is_add_wx:'',
          is_inspection:'',
          is_recharge:''
        }

      },



    }
  };
</script>

<style scoped>
  #container_add {
    height: 90%;
    width: 65%;
    float: left;
  }

  .order-model {
    margin: 20px 0;
  }


  .mode-data {

    margin: 20px 0;
  }

  iframe {
    width: 100%;
    border: medium none;
    height: 100%;
  }

  h4 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
  }

  h5 {
    font-size: 20px;
    font-weight: normal;
  }

  .text-btn {
    font-size: 18px;
    margin-left: 20px;
    padding: 5px;
    display: block;
  }

  .box>div {
    margin: 20px 0;
  }

  .tag {
    padding: 5px;
    border-radius: 5px;
  }

  .tag {
    background-color: red;
  }

  .tag.active {
    background-color: green;
  }
  .el-checkbox{
    margin: 5px!important;
  }
</style>